import ApiService from "../ApiService";
const {REACT_APP_REST_ENDPOINT} = process.env;

export default class AuthService {

    static register = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/registrazione`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static requestForm = (data) => {//NEW
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/formRichiesta`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static resendEmailRegister = (email) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/reinoltroEmail`;
            ApiService.postRequest(resolve, reject, url, email);
        });
    };

    static login = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/login`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    };

    static refreshToken = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/refresh-token`;
            ApiService.refreshTokenRequest(resolve, reject, url)
        });
    }
    
    static resetPassword = async (data, token) => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
            return new Promise((resolve, reject) => {
                fetch(`${REACT_APP_REST_ENDPOINT}/utenti/cambioPassword`, {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: headers,
                }).then(response => {
                    if (!response.ok) {
                    response.json().then(errorData => {
                        reject(errorData); 
                    });
                    } else {
                    response.json().then(data => {
                        resolve(data); 
                    });
                    }
                })
                .catch(error => {
                    reject(error); 
                });
                });            
    }
    
    static forgotPassword = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/recupera-password`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    };

    static getUserByUsername = (username) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/findByUsername`;
            ApiService.postRequest(resolve, reject, url, {username})
        });
    }

    static getUserInfoLoggedIn = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/utenti/userDetails`;
        return ApiService.getRudeRequest(url).then(res => res.json());
    }

    // static completeProfile = async (data, token) => {
    //     const headers = {
    //         'Authorization': `Bearer ${token}`,
    //         'Content-Type': 'application/json'
    //     };
    //     return new Promise((resolve, reject) => {
    //         fetch(`${REACT_APP_REST_ENDPOINT}/utenti/completamento-profilo`, {
    //             method: "PUT",
    //             body: JSON.stringify(data),
    //             headers: headers,
    //         }).then(response => {
    //             if (!response.ok) {
    //             response.json().then(errorData => {
    //                 reject(errorData); 
    //             });
    //             } else {
    //             response.json().then(data => {
    //                 resolve(data); 
    //             });
    //             }
    //         })
    //         .catch(error => {
    //             reject(error); 
    //         });
    //     });              
    // };

    /*
    static completeProfile = async (data, token) => {
        const headers = {
            'Authorization': `Bearer ${token}`
            // Non specificare 'Content-Type' per FormData!
        };
    
        const formData = new FormData();
        for (const key in data) {
            if (key === "documentoRiconoscimento" || key === "codiceFiscale" || key === "documentoRiconoscimentoRetro" || key === "codiceFiscaleRetro") {
                formData.append(key, data[key]); // file
            } else {
                formData.append(key, data[key]); // campi testuali
            }
        }
        return new Promise((resolve, reject) => {
            fetch(`${REACT_APP_REST_ENDPOINT}/utenti/completamento-profilo`, {
                method: "POST", // cambia in POST se vuoi separare da PUT JSON
                body: formData,
                headers: headers
            })
            .then(response => {
                if (!response.ok) {
                    response.json().then(errorData => reject(errorData));
                } else {
                    response.json().then(data => resolve(data));
                }
            })
            .catch(error => reject(error));
        });
    };
    */


    static completeProfile = async (formData, token) => {
        // NOTA: Riceve il FormData già pronto E il token, come nel tuo codice originale.
        const headers = {
            'Authorization': `Bearer ${token}`
            // NON specificare 'Content-Type', il browser lo imposta da solo per FormData.
        };
        console.log(formData);
        return new Promise((resolve, reject) => {
            fetch(`${process.env.REACT_APP_REST_ENDPOINT}/utenti/completamento-profilo`, {
                method: "POST", // Il backend si aspetta POST per i file
                body: formData, // Invia il FormData direttamente
                headers: headers
            })
            .then(response => {
                if (!response.ok) {
                    response.json().then(errorData => reject(errorData));
                } else {
                    response.json().then(data => resolve(data));
                }
            })
            .catch(error => reject(error));
        });
    };

}